import React, { useState, useEffect } from "react";
import ContactInfo from "../contactInfo";
import { motion } from "framer-motion";
import NavItem from "./navItems";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { navItems } from "../../utiles/constant";
import { BarIcon, CrossIcon } from "../../assets/icons";
import logo from '../../assets/images/logo.png'
import { mobilenumber } from "../../utiles/constant";
import { useInfo } from "../../utiles/InfoContext";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [activeItem, setActiveItem] = useState(null);
  const [nestedDropdowns, setNestedDropdowns] = useState({});
  const navigate = useNavigate();
  const { infoEnabled, setInfoEnabled } = useInfo();
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    if (searchParams.has("info")) {
      setInfoEnabled(true);
    }
  }, [location.search, setInfoEnabled]);

  const shouldShowContactInfo = infoEnabled;

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const toggleNestedDropdown = (label) => {
    setNestedDropdowns((prev) => ({
      ...prev,
      [label]: !prev[label],
    }));
  };

  const handleNavItemClick = (label, to) => {
    setActiveItem(label);
    setIsOpen(false);
    setNestedDropdowns({});
    if (to) {
      navigate(to);
    }
  };

  const openWhatsApp = (phoneNumber, message) => {
    const encodedMessage = encodeURIComponent(message);
    const url = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    console.log(`Opening WhatsApp with URL: ${url}`); // Debugging
    window.open(url, "_blank");
  };

  return (
    <>
      {shouldShowContactInfo && <ContactInfo />}
      <nav className="text-sm bg-white px-4 sm:px-8 md:px-9 lg:px-16 xl:px-32 py-4 relative font-poppins w-full mx-auto">
        <div className="flex items-center justify-between">
          <Link to="/" className="inline-block">
            <img
              src={logo}
              alt="Logo"
              className="h-10 w-45 object-fill"
            />
          </Link>
          {/* Desktop Menu and Contact Button */}
          <div className="hidden lg:flex items-center space-x-10 ml-auto">
            <div className="flex items-center space-x-8 mb-1">
              {navItems.map((item, index) => (
                <NavItem
                  key={index}
                  label={item.label}
                  to={item.to}
                  isActive={activeItem === item.label}
                  onClick={() => handleNavItemClick(item.label, item.to)}
                >
                  {item.isDropdown &&
                    item.dropdownColumns.map((column, colIdx) => (
                      <div key={colIdx}>
                        <div className="font-bold">{column.columnLabel}</div>
                        {column.items.map((dropdownItem) => (
                          <Link
                            key={dropdownItem.label}
                            to={dropdownItem.to}
                            className="block px-4 py-2 text-sm text-black"
                            onClick={() => {
                              if (dropdownItem.phoneNumber) {
                                openWhatsApp(dropdownItem.phoneNumber, dropdownItem.message);
                              } else {
                                handleNavItemClick(dropdownItem.label, dropdownItem.to);
                              }
                            }}
                          >
                            {dropdownItem.label}
                          </Link>
                        ))}
                      </div>
                    ))}
                </NavItem>
              ))}
            </div>
            {/* Desktop Contact Button */}
            <Link target="_blank"
              to={`https://wa.me/${mobilenumber.phone}`}
              className="bg-primary text-white px-4 py-2 rounded transition-colors font-poppins text-xs-14"
            >
              Contact

            </Link>
          </div>

          {/* Mobile Menu Toggle and "Let's Talk" Button */}
          <div className="lg:hidden flex items-center space-x-2">
            <button
              onClick={toggleMenu}
              className="focus:outline-none h-7 w bg-primary p-1 rounded-md"
            >
              {isOpen ? <CrossIcon /> : <BarIcon />}
            </button>
            <Link
              to={`https://wa.me/${mobilenumber.phone}`}
              className="bg-primary text-white px-3 py-2 rounded transition-colors font-poppins text-sm"
            >
              Let's Talk.
            </Link>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            className="lg:hidden bg-white text-black shadow-lg py-4 overflow-auto z-50 absolute left-0 right-0 top-full"
          >
            <div className="flex flex-col items-center ">
              <div className="items-start ">
              {navItems.map((item) => (
                <div key={item.label} className="relative">
                  {item.label === "Hire Developers" ? (
                    <>
                      <button
                        onClick={() => toggleNestedDropdown(item.label)}
                        className="block w-full text-left px-4 py-2 text-sm text-black"
                      >
                        {item.label} {nestedDropdowns[item.label] ? "-" : "+"}
                      </button>
                      {nestedDropdowns[item.label] && (
                        <div className="pl-4">
                          {item.dropdownColumns.map((column, colIdx) => (
                            <div key={colIdx} className="py-4">
                              <button
                                onClick={() =>
                                  toggleNestedDropdown(column.columnLabel)
                                }
                                className="font-bold text-left w-full text-xs-14"
                              >
                                {column.columnLabel}{" "}
                                {nestedDropdowns[column.columnLabel]
                                  ? "-"
                                  : "+"}
                              </button>
                              {nestedDropdowns[column.columnLabel] && (
                                <div className="pl-4">
                                  {column.items.map((dropdownItem) => (
                                    <Link
                                      key={dropdownItem.label}
                                      to={dropdownItem.to}
                                      className="block px-4 py-2 text-sm text-black"
                                      onClick={() => {
                                        if (dropdownItem.phoneNumber) {
                                          openWhatsApp(dropdownItem.phoneNumber, dropdownItem.message);
                                        } else {
                                          handleNavItemClick(dropdownItem.label, dropdownItem.to);
                                        }
                                      }}
                                    >
                                      {dropdownItem.label}
                                    </Link>
                                  ))}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </>
                  ) : (
                    <Link
                      to={item.to}
                      className="block w-full text-left px-4 py-2 text-sm text-black"
                      onClick={() => handleNavItemClick(item.label, item.to)}
                    >
                      {item.label}
                    </Link>
                  )}
                </div>
              ))}
              </div>
            </div>
          </motion.div>
        )}
      </nav>
    </>
  );
}

export default Navbar;
